/*
 * Clipboard Messages
 *
 * This contains all the text for the Clipboard Provider and its helper functions.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.containers.Clipboard';

export default defineMessages({
  screenSuccess: {
    id: `${scope}.copy.screen.success`,
    defaultMessage: 'Your screen "{title}" was copied.',
  },
  screenError: {
    id: `${scope}.paste.screen.error`,
    defaultMessage: 'Cannot create screen from invalid target!',
  },
  stageElementSuccess: {
    id: `${scope}.copy.stage.element.success`,
    defaultMessage: 'Successfully copied stage element.',
  },
  stageElementError: {
    id: `${scope}.paste.stage.element.error`,
    defaultMessage: 'Cannot create stage element from invalid target!',
  },
  screenPasteSuccess: {
    id: `${scope}.paste.screen.success`,
    defaultMessage: 'Your screen "{title}" was pasted.',
  },
});
